<template>
  <button type="button" class="button-timer" @click="click">
    <span class="button-timer__frame">
      <span class="button-timer__half button-timer__half--left">
        <span class="button-timer__fill" ref="left"></span>
      </span>
      <span class="button-timer__half button-timer__half--right">
        <span class="button-timer__fill" ref="right"></span>
      </span>
    </span>
    <span class="button-timer__overlay">
      <span class="button-timer__icon" v-if="icon">
        <Icon v-if="icon" :name="icon"/>
      </span>
    </span>
  </button>
</template>

<script>
import Icon from '@/components/Icon/Icon.vue';

export default {
  name: 'ButtonTimer',
  components: { Icon },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    icon() {
      return this.data?.icon || '';
    },
    animate() {
      return this.data?.animate || false;
    },
    time() {
      return this.data?.time || 8;
    },
  },
  methods: {
    click() {
      this.$emit('onClick');
    },
    animation() {
      const { left, right } = this.$refs;

      if (!left || !right) return;

      const tl = this.$gsap.timeline({ paused: true });

      tl.fromTo(
        left,
        { rotate: 0 },
        { rotate: 180, duration: this.time / 2, ease: 'none' },
      )
        .fromTo(
          right,
          { rotate: 0 },
          {
            rotate: 180,
            duration: this.time / 2,
            ease: 'none',
            onComplete: () => {
              this.$emit('onComplete');
            },
          },
        );

      tl.play();
    },
  },
  mounted() {
    if (this.animate) {
      this.animation();
    }
  },
};
</script>

<style lang="scss" scoped>
@import "ButtonTimer";
</style>
